import classNames from 'classnames';
import { useController } from 'react-hook-form';
import { Dropdown, DropdownProps } from 'primereact/dropdown';
import FormErrorMessage from '../../FormErrorMessage';
import { StaticFormFieldProps } from '../../types/types';
import { OPTION_LABEL_KEY, OPTION_VALUE_KEY } from '../../../constants/dynamic-form-config';

type Props = StaticFormFieldProps & DropdownProps;

export default function SelectField({
  name,
  control,
  required,
  rules,
  label,
  help,
  optionLabel,
  optionValue,
  callback,
  ...rest
}: Props) {
  const { field, fieldState } = useController({
    name: name as string,
    control,
    rules,
  });

  return (
    <div className="field">
      { label && <label htmlFor={field.name} className={classNames({ 'p-error': fieldState.error })}>{label}</label>}
      <Dropdown
        {...rest}
        className={classNames({ 'w-full': true, 'p-invalid': fieldState.error })}
        value={field.value}
        data-testid={field.name}
        onChange={(e) => {
          field.onChange(e.value);
          if (callback) {
            callback(e.value);
          }
        }}
        optionLabel={optionLabel || OPTION_LABEL_KEY}
        optionValue={optionValue || OPTION_VALUE_KEY}
      />
      {help && <span className="form-help">{help}</span> }
      <FormErrorMessage label={fieldState.error?.message} />
    </div>
  );
}
